import appModule from '@/app-module';

export default {
  beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.unauth) {
      next();
      return;
    }

    appModule.storeAsync().dispatch('auth/waitUntilInit').then(() => {
      if (appModule.storeAsync().getters['auth/authenticated']) {
        next('/');
      } else {
        next();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/auth/guards/unauth-guard-mixin.js